import { useAuth } from '@flipster/features/src/shared/auth/state';
import { useResponsive } from '@flipster/react/misc/responsive/legacy';
import { getFlipsterConfigsV1Key, getLocalStorage, setLocalStorage } from '@flipster/utils/localStorage';

export const useRewardHubPopUp = () => {
  const { user } = useAuth();
  const { isMobile } = useResponsive();

  if (!user?.userId) return {};

  const skipRewardHubConfirmKey = getFlipsterConfigsV1Key(user.userId, 'skipRewardHubConfirm');
  const isShowRewardHubAlert = isMobile && !user?.kycActivatedAt && !getLocalStorage(skipRewardHubConfirmKey);

  const closeRewardHubPopUp = () => {
    setLocalStorage(skipRewardHubConfirmKey, true);
  };

  return {
    isShowRewardHubAlert,
    closeRewardHubPopUp,
  };
};
